import { render, staticRenderFns } from "./ListRenewals.vue?vue&type=template&id=25eb6e00"
import script from "./ListRenewals.vue?vue&type=script&lang=js"
export * from "./ListRenewals.vue?vue&type=script&lang=js"
import style0 from "./ListRenewals.vue?vue&type=style&index=0&id=25eb6e00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports